module.exports = __webpack_public_path__ + "img/ground.289c4927.svg";